import { Project } from "./project";
import { Skill } from "./skill";
import { Company } from "./company";

export interface Job {
  id: string | number;
  title: string;
  description: string;
  achievements: string[];
  startDate: Date;
  endDate: Date | null;
  link: string;
  images: string[];
  tools: Skill[];
  skills: Skill[];
  position: Position[];
  projects: Project[];
  company: Company;
}

export interface Position {
  id: string;
  title: string;
  startDate: Date;
  endDate: Date;
}

export interface JobWithTimestamp {
  id: string | number;
  title: string;
  description: string;
  achievements?: string[];
  startDate: unknown;
  endDate: unknown;
  link: string;
  images: string[];
  tools: Skill[];
  skills: Skill[];
  position?: Position[];
  projects?: Project[];
  company?: Company;
}

export const EMPTY_JOB: Job = {
  id: null,
  title: null,
  description: null,
  achievements: [],
  startDate: null,
  endDate: null,
  link: null,
  images: [],
  tools: [],
  skills: [],
  position: [],
  projects: [],
  company: null,
};
